/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Org_AllocInputs */

const cs_billing_org_alloc = /** @type {(inputs: Billing_Org_AllocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbývající firemní alokace`)
};

const en_billing_org_alloc = /** @type {(inputs: Billing_Org_AllocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Org allocation remaining`)
};

/**
* | output |
* | --- |
* | "Org allocation remaining" |
*
* @param {Billing_Org_AllocInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_org_alloc = /** @type {((inputs?: Billing_Org_AllocInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Org_AllocInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_org_alloc(inputs)
	return cs_billing_org_alloc(inputs)
});